import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import '../Leaves/Leave.css';


const inivalue = {
    department_name: "",
    paid_leave_allowed: ""
};

const Adddesignation = (props) => {
    const classes = props;
    const [qulifi, setQulifi] = useState(inivalue);
    const [formErrors, setFormErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (props && props.authToken === false) {
            // history.push('/login');
            // alert("hardik")
        }
    }, [props, history]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setQulifi({ ...qulifi, [name]: value });
        if (formErrors[name]) {
            const stringValue = typeof value === "string" ? value.trim() : value;
            if (stringValue !== "") {
                setFormErrors((prev) => {
                    const next = { ...prev };
                    delete next[name];
                    return next;
                });
            }
        }
    };

    const validate = (values) => {
        let errors = {};
        if (!values.department_name) {
            errors.department_name = "Cannot be blank";
        }
        if (!values.paid_leave_allowed) {
            errors.paid_leave_allowed = "Cannot be blank";
        }
        return errors;
    };

    const createDesignation = async () => {
        setSubmitLoading(true);
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode()
        });
        try {
            let create = await AuthApi.Departmentcreate(qulifi);
            swal.close();
            if (create && create.status === true) {
                swal("Success", "Designation added successfully", "success").then(() => {
                    history.push('/designation');
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: create && create.message ? create.message : "Something went wrong, Please try later!"
                });
            }
        } catch (error) {
            swal.close();
            console.error("Error updating qulification:", error);
            swal("Error", "An unexpected error occurred", "error");
        } finally {
            setSubmitLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitLoading) {
            return;
        }
        const errors = validate(qulifi);
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        await createDesignation();
    };

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <div className="holiday-breadcrumb-card">
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="Designation"
                                    primaryPageLink="/designation"
                                    isSecondaryPage={true}
                                    secondaryPageName="Add Designation" />
                        </div>

                        {/* {
                            props.authToken === false ? <AuthCheckComponent authToken={props.authToken} /> : ""
                        } */}
                        <div className="holiday-form-card">
                                        <Typography variant="h2" className="common-form-page-title holiday-form-title">Add Designation</Typography>
                                        <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="department_name"
                                                        name="department_name"
                                                        label="Designation Name"
                                                        variant="outlined"
                                                        error={formErrors.department_name && true}
                                                        value={qulifi.department_name}
                                                        onChange={handleChange}
                                                        className={formErrors.department_name && "input-error"}
                                                    />
                                                    {formErrors.department_name && (
                                                        <span className="error">{formErrors.department_name}</span>
                                                    )}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="paid_leave_allowed"
                                                        name="paid_leave_allowed"
                                                        label="Allowed Paid Leave"
                                                        variant="outlined"
                                                        type="number"
                                                        inputProps={{ min: 0 }}
                                                        error={formErrors.paid_leave_allowed && true}
                                                        value={qulifi.paid_leave_allowed}
                                                        onChange={handleChange}
                                                        className={formErrors.paid_leave_allowed && "input-error"}
                                                    />
                                                    {formErrors.paid_leave_allowed && (
                                                        <span className="error">{formErrors.paid_leave_allowed}</span>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <div className="holiday-form-actions">
                                                <Button type="submit" className="btn-success" style={{ textTransform: 'none' }} variant="contained" color="primary" disabled={submitLoading}>
                                                    {submitLoading ? <><CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Saving...</> : 'Save'}
                                                </Button>
                                                <Button type="button" className="btn-cancel" style={{ textTransform: 'none' }} disabled={submitLoading} onClick={(e) => { e.preventDefault(); history.push('/designation'); }}>Cancel</Button>
                                            </div>
                                        </form>
                        </div>
                    </div>
                } />
            <Footer />
        </div>
    );
};

export default Adddesignation;
